import { isFalseOrEmpty } from '../../platformui/Helpers/helpers';
export const CONST_ALL = 'ALL';

// Remove filter item from list of selected filters.
const removeFilterFromSelected = (arr, item) =>
  arr.filter((i) => !hasFilterItem(item)(i));

/** Remove time format if it is 00:00:00 */
export function removeZeroTime(str) {
  if (!isString(str)) {
    return str;
  }
  if (str.includes('00:00:00')) {
    return str.replace('00:00:00', '');
  }
  return str;
}

export function formatFilterName(str) {
  return removeZeroTime(str);
}

export function toggleFilterValue(value, arr) {
  if (arr.some(hasFilterItem(value))) {
    return removeFilterFromSelected(arr, value);
  } else {
    return [...arr, value];
  }
}

export const objKeyIs = (key, value) => (obj) => obj[key] === value;

export function deleteFromArray(predicate, arr) {
  return arr.filter((i) => !predicate(i));
}

/** lowercase, lc("STR") === "str" */
const lc = (str) => str.toLowerCase();

export function createFilterItem({ name, column, table, value }) {
  return {
    table,
    column,
    name,
    value,
  };
}

export const inTable = (table) => objKeyIs('table', table);

export const inFilter = (name) => objKeyIs('name', name);

export const inTableColumn = (table, column) => (item) => {
  return item.table === table && item.column === column;
};

export const hasFilterItem = ({ column, table, name, value }) => (item) => {
  return (
    item.table === table &&
    item.column === column &&
    item.name === name &&
    item.value === value
  );
};

export function isAllSelected({ filters, selected, name, column, table }) {
  if (selected.length === 0) {
    return false;
  }
  return filters.every((filter) => {
    return selected.some(
      hasFilterItem({ column, table, name, value: filter['Värde'] })
    );
  });
}

export function getFiltersForTable(filters, table) {
  return filters.filter(inTable(table));
}

export function getFiltersByName(filters, Filternamn) {
  return filters.filter(inFilter(Filternamn));
}

export function visualsToExclude(visual) {
  return (
    visual.title !== undefined &&
    visual.type !== 'card' &&
    visual.type !== 'tableEx'
  );
}

export function createVisualObject({ name, title }) {
  return {
    name,
    title,
  };
}

export function getSelectedValues(items) {
  // Return values and remove ALL option.
  return items.map((i) => i.value).filter((s) => s !== CONST_ALL);
}

/**
 * This should not run on server, only in the client.
 *
 * Uses `window['powerbi-client'].models`.
 */
export function exportVisualData(data, report, fileType = 'csv') {
  const models = window['powerbi-client'].models;

  report.getPages().then(function (pages) {
    var activePage = pages.find(function (page) {
      return page.isActive;
    });

    activePage.getVisuals().then(function (visuals) {
      var visual = visuals.find(function (visual) {
        return visual.name === data.name;
      });

      visual
        .exportData(models.ExportDataType.Summarized)
        .then(function (result) {
          exportData({
            type: fileType,
            filter: data.filters,
            data: result.data,
            title: visual.title,
          });
        })
        .catch(err => console.log(err));
    });
  });
}

function exportData({ data, title, filter, type }) {
  // Replace whitespaces with underscore for better file name.
  let filename = lc(title.replace(/ /g, '_'));

  let hiddenElement = document.createElement('form');
  document.body.appendChild(hiddenElement);

  let dataElement = document.createElement('input');
  dataElement.type = 'hidden';
  dataElement.name = 'data';
  dataElement.value = data;
  hiddenElement.appendChild(dataElement);

  let filterElement = document.createElement('input');
  filterElement.type = 'hidden';
  filterElement.name = 'filter';
  filterElement.value = filter;
  hiddenElement.appendChild(filterElement);

  let fileNameElement = document.createElement('input');
  fileNameElement.type = 'hidden';
  fileNameElement.name = 'filename';
  fileNameElement.value = `${filename}.${type}`;
  hiddenElement.appendChild(fileNameElement);

  let titleElement = document.createElement('input');
  titleElement.type = 'hidden';
  titleElement.name = 'title';
  titleElement.value = title;
  hiddenElement.appendChild(titleElement);

  let action = `/export/powerbi/${type === 'csv' ? 'csv' : 'openxml'}`;
  hiddenElement.action = action;
  hiddenElement.method = 'POST';
  hiddenElement.submit();
}

export function removeAllOptionFromFilterItems(filterItems) {
  return filterItems.filter((i) => i !== CONST_ALL);
}

export function formatFiltersForExport(filters) {
  return JSON.stringify(
    filters.reduce((acc, cur) => {
      acc[cur.column] = removeAllOptionFromFilterItems(cur.items);
      return acc;
    }, {})
  );
}

export function createFilterObject({ table, column, filterValues }) {
  return {
    $schema: 'https://powerbi.com/product/schema#basic',
    target: {
      table: table,
      column: column,
    },
    operator: 'In',
    values: filterValues,
    filterType: 1,
  };
}

export function createFilter(table, column, items) {
  const filterValues = removeAllOptionFromFilterItems(items);
  if (filterValues.length === 0) return false;
  return createFilterObject({ table, column, filterValues });
}

export function createFilters(filterGroups) {
  if (!filterGroups) return false;
  return filterGroups
    .map((group) => createFilter(group.table, group.column, group.items))
    .filter(Boolean);
}

export function searchFilterItem(query) {
  return function findItemInQuery(item) {
    const a = item['Värde'].toString().toUpperCase();
    const b = query.toUpperCase();
    return a.includes(b);
  };
}

export function removeDuplicates(arr) {
  const { unique } = arr.reduce(
    (acc, cur) => {
      if (acc.all.includes(cur['Värde'])) {
        return acc;
      }

      acc.all.push(cur['Värde']);

      return {
        unique: [...acc.unique, cur],
        all: acc.all,
      };
    },
    {
      unique: [],
      all: [],
    }
  );
  return unique;
}

export function flattenFilters(filters, Tabell, Kolumn) {
  let _filters = [];

  if (filters['Värde']) {
    _filters.push({
      Värde: filters['Värde'],
      Tabell: Tabell,
      Kolumn: Kolumn,
    });
  }

  if (!isFalseOrEmpty(filters['Värden'])) {
    _filters = _filters.concat(
      filters['Värden'].flatMap((i) => {
        return flattenFilters(i, filters['Tabell'], filters['Kolumn']);
      })
    );
  }
  // console.count(`${Tabell}-${Kolumn}`);

  return _filters;
}

export function isString(maybeString) {
  return typeof maybeString === 'string';
}

export function isFilterLeafNode(filter) {
  if (filter['Värden'].length === 0) return true;
  return false;
}
